import { useState, useEffect } from 'react';
import Abouta from './Pages/About';
import Contact from './Pages/Contact.js';
import Homepage from './Pages/Homepage';
import Ourteams from './Pages/Ourteam';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Services from './Pages/Services';
import Nav1 from './Components/Nav';
import Footer from './Components/Footer';
import Copyright from './Components/Copyright';
import Projects from './Pages/Projects';
import Privacy from './Pages/Privacy';
import Faq from './Pages/Faq';
import Terms from './Pages/Terms';
import Preloader from './Components/Preloader';
import Start from './Components/form'
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init();
}, [])
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 300); 

    return () => clearTimeout(timer); 
  }, []);
  return (
    <div className="app">
      {loading ? (
        <>
          <Preloader/>
        </>
      ) : (
        <>
          <Router>
        <Nav1/>
      <Routes>
        <Route path="/" element={<Homepage/>}/>
        <Route path="/home" element={<Homepage/>}/>
        <Route path="/contact" element={<Contact/>}/>
        <Route path="/about" element={<Abouta/>}/>
        <Route path='/ourteam' element={<Ourteams/>}/>
        {/* <Route path='/services' element={<Services/>}/> */}
        <Route path="/project" element={<Projects/>}/> 
        <Route path="/privacy" element={<Privacy/>}/> 
        <Route path='/faq' element={<Faq/>}/>
        <Route path='/t&c' element={<Terms/>}/>
        <Route path='/start' element={<Start/>}/>
      </Routes>
      <Footer/>
      <Copyright/>
    </Router>
        </>
      )}
    </div>
  );
};

export default App;
